import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { chipClasses } from '@mui/material/Chip'

export const useDataGridToolbarHistoryDialogStyles = makeStyles((theme: Theme) => ({
  dialogPaper: {
    minHeight: 200,
    maxHeight: '80vh'
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  closeButton: {
    color: theme.palette.grey[500]
  },
  dialogContent: {
    padding: 0
  },
  dialogContentEmpty: {
    padding: 0,
    display: 'flex',
    alignItems: 'center'
  },
  emptyStateBox: {
    display: 'flex',
    padding: theme.spacing(1),
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    flex: '1 0 0',
    backgroundColor: '#E9F5FE'
  },
  searchIcon: {
    fontSize: 32,
    color: '#0000008A'
  },
  emptyText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: '1rem'
  },
  contentBox: {
    padding: theme.spacing(2, 3)
  },
  divider: {
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(3, -3)
  },
  dateHeader: {
    fontWeight: 'normal',
    marginBottom: theme.spacing(1.5)
  },
  recordsBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1)
  },
  recordBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    cursor: 'pointer'
  },
  noFiltersText: {
    fontStyle: 'italic'
  },
  chip: {
    backgroundColor: '#e3f2fd',
    color: '#000000',
    fontWeight: 400,
    fontSize: '0.8rem',
    height: 28,
    cursor: 'pointer',
    [`& .${chipClasses.label}`]: {
      padding: theme.spacing(0.5, 2),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  chipLabelBold: {
    fontWeight: 'bold'
  }
}))
